import GravityAdapter from 'district-ui-client/adapters/gravity'

export default class SchoolAdapter extends GravityAdapter {}
